<template>
  <div id="hkVideo" class="hk-video">
    <div
      :id="`playWnd${HKIdx}`"
      class="playWnd"
      style="width: 100%; height: 100%"
    ></div>
    <p style="display: none">{{ code }}</p>
  </div>
</template>
<script>
import "../assets/jsencrypt.min.js";
import $ from "jquery";
// import { WebControl } from "../assets/jsWebControl-1.0.0.min.js";
import { WebControl } from "../assets/web-control_1.2.5.min.js";
// import axios from "axios";
import axios from "./axios";
import { hex_md5 } from "./../utils/md5";
import { CALLBACK_ENUM, makeMessage } from '../utils/enum.js';
import { debounce, throttle, UPDATE_REFRESH_INTERVAL } from '../utils/fn';
import { newGUID } from '../utils/guid.js';
import { URLS } from '../config.js';

// console.log(WebControl)
window.WebControl = WebControl;

export default {
  name: "HKVideo",
  props: {
    code: String,
    config: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      initCount: 0,
      pubKey: "",
      HKwidth: "",
      HKheight: "",
      HKIdx: '', // Dom Id
      // HKvideoCode: '99146cc6c59d4101ac329edfa9ac313e',
      HKvideoCode: "",
      HKstartTime: "",
      HKendTime: "",
      oWebControl: null,
      reConnectTimer: null,
      playMode: 0,
      appKey: "",
      secret: "",
      ip: "",
      port: "",
      oWebCtrArry: [],
      initFlag: false, // init标志判断 禁止多次调用
      lastHKVideoCode: "",
      iframePos: {}, // iframe相对文档的位置
      iframeClientPos: null, // iframe相对视窗的位置
      iframeParentShowSize: null, // 视窗大小 width height
      handleMessageCopy: null
    };
  },
  beforeDestroy() {
    this.dispose();
  },
  watch: {
    code: {
      async handler(nVal) {
        if (!nVal) {
          console.log("请提供海康Code播放！");
          return;
        }
        console.log('hk-code',nVal);
        if (this.oWebControl) {
          await this.dispose();
        }
        this.HKvideoCode = nVal;
        // DOM ID 即使是同
        this.HKIdx = nVal.indexOf(',') > -1 ? hex_md5(`${nVal}`) : nVal;
        // 以Code为标准进行初始化Config
        this.initFlag = false;
        this.init();
        // this.initHkVideo(this.HKvideoCode);
      },
      immediate: true,
    },
  },
  beforeMount() {
    /* this.WebControl = WebControl; */
  }, // 调用电脑中的插件
  mounted() {
    // 监听滚动条scroll事件，使插件窗口跟随浏览器滚动而移动
    $(window).scroll(() => {
      if (this.oWebControl != null) {
        this.resizeHKwindow();
      }
    });

    // 监听真实dom级size变化
    this.listenDomResize();
    // 监听真实dom级销毁
    this.listenDestory();
    // 监听外部dom attribute改变
    this.listenExtenalDomChange();

    this.handleMessageCopy = this.handleMessage.bind(this);
    // this.initEventListener();
  },
  methods: {
    disposeEventListener() {
      window.removeEventListener('message', this.handleMessageCopy)
    },
    initEventListener() {
      window.addEventListener("message", this.handleMessageCopy);
    },
    handleMessage(e) {
      if (e && e.data) {
        switch (e.data.action) {
          case "updatePos": // 更新插件位置：JS_CreateWnd时需要父页面计算滚动条偏移量，初始偏移量叠加该偏移量作为iframe的偏移量，防止插件窗口与DIV窗口初始不贴合情况
            var scrollValue = e.data.scrollValue; // 滚动条滚动偏移量
            this.oWebControl.JS_SetDocOffset({
              left: this.iframePos.left + scrollValue.left,
              top: this.iframePos.top + scrollValue.top,
            }); // 更新插件窗口位置

            this.oWebControl.JS_Resize(this.HKwidth, this.HKheight);
            this.setWndCover();
            break;
          case "updateInitParam":
            this.iframePos = e.data.iframeOffset; // iframe与文档的偏移量
            this.iframeClientPos = e.data.iframeClientPos; // iframe相对视窗的位置
            this.iframeParentShowSize = e.data.showSize; // 视窗大小
            break;
          case "resize":
            this.iframeParentShowSize = e.data.showSize; // 视窗大小
            this.iframePos = e.data.iframeOffset; // iframe与文档的偏移量
            this.iframeClientPos = e.data.iframeClientPos; // iframe相对视窗的位置
            this.setWndCover();
            break;
          case "scroll":
            this.iframeParentShowSize = e.data.showSize; // 视窗大小
            this.iframePos = e.data.iframeOffset; // iframe与文档的偏移量
            this.iframeClientPos = e.data.iframeClientPos; // iframe相对视窗的位置
            var scrollValue = e.data.scrollValue; // 滚动条滚动偏移量
            if (this.oWebControl) {
              this.oWebControl.JS_SetDocOffset({
                left: iframePos.left + scrollValue.left,
                top: iframePos.top + scrollValue.top,
              }); // 更新插件窗口位置
              this.oWebControl.JS_Resize(800, 400);
              this.setWndCover();
            }
            break;
          default:
            break;
        }
      }
    },
    // 更新对应配置
    init() {
      return new Promise((resolve, reject) => {
        if (this.config && this.config.appKey && this.config.secret) {
          try {
            this.appKey = this.config.appKey;
            this.secret = this.config.secret;
            this.ip = this.config.ip;
            // 端口必须是Int类型
            this.port = Number(this.config.port);
            this.$nextTick(() => {
              this.initHkVideo(this.HKvideoCode);
            });
            resolve("success");
          } catch (error) {
            reject(error);
            console.error(error);
          }
        } else {
          /**
           * 此处0.4.6版本开始 携带code参数 兼容新版后台
           * 后台分为携带code方式 与不携带code方式 v21.9之后进行区分
           * 接口携带code 择会去拉插件中心配置 插件中心如果没有对应配置 则会去拉本地配置
           * 接口不携带code 则会去拉本地java默认配置
           */

          const url =
            this.$parent.proxyHost + URLS.getHKConfig;
          const params = {
            code: this.code,
          };
          axios
            .post(url, params)
            .then((res) => {
              if (res.data.status === 200 && res.data.code === 200) {
                // 此处兼容后台版本后续Key改动 优先取appKey 取不到取key值
                this.appKey = res.data.result.appKey || res.data.result.key;
                this.secret = res.data.result.appSecret || res.data.result.secret_key;
                // 如果配置设置了外网地址则以外网地址为标准进行播放
                if (res.data.result.external_host) {
                  this.ip = res.data.result.external_host.split(":")[0];
                  this.port = res.data.result.external_host.split(":")[1] * 1;
                } else {
                  this.ip = res.data.result.host.split(":")[0];
                  this.port = res.data.result.host.split(":")[1] * 1;
                }
                this.$nextTick(() => {
                  this.initHkVideo(this.HKvideoCode);
                });
                resolve(res);
              } else {
                reject(res);
              }
            })
            .catch((err) => {
              reject(err);
            });
        }
      });
    },
    // 兼容Iframe改变
    resizeHKwindow() {
      if (!this.oWebControl) {
        return;
      }
      const dom = document.getElementById(`playWnd${this.HKIdx}`)

      if (self.frameElement && self.frameElement.tagName == "IFRAME") {
        var ifr = self.frameElement;
        var ifRect = ifr.getBoundingClientRect();
        var ifT = ifRect.top;
        var ifL = ifRect.left;
        this.oWebControl.oDocOffset.top = ifT;
        this.oWebControl.oDocOffset.left = ifL;
      }

      if (!dom) {
        return;
      }
      this.$nextTick(() => {
        this.HKwidth = dom.clientWidth;
        this.HKheight = dom.clientHeight;
        this.oWebControl.JS_Resize(this.HKwidth, this.HKheight);
      });
    },
    resizePlayWindows() {
      if (this.oWebControl != null) {
        this.$nextTick(() => {
          this.HKwidth = $(`#playWnd${this.HKIdx}`).clientWidth;
          this.HKheight = $(`#playWnd${this.HKIdx}`).clientHeight;
          this.oWebControl.JS_Resize(this.HKwidth, this.HKheight);
        });
      }
    },
    initHkVideo(elIdx) {
      if (this.initFlag) {
        console.error("禁止重复初始化对象！");
        return;
      }
      // 兼容新版Code
      this.interceptCode();
      this.initFlag = true;
      this.lastHKVideoCode = this.HKvideoCode;

      const HkDom = $(`#playWnd${this.HKIdx}`)[0]
      this.HKwidth = HkDom.clientWidth;
      this.HKheight = HkDom.clientHeight;
      this.initPlugin(() => {
        if (this.HKvideoCode.indexOf(',') > -1) {
          this.previewMultVideo(this.HKvideoCode);
        } else {
          this.previewVideo(this.HKvideoCode);
        }
      });
    },
    // 兼容性Code修改 针对Code格式 V1_hk_panjinliaodongwanxin_3_509005815b374688a6c1bfdd01103942
    interceptCode() {
      if (this.HKvideoCode.indexOf("V1_") > -1) {
        const splitArray = this.HKvideoCode.split("_");
        if (splitArray.length > 0) {
          this.HKvideoCode = splitArray[splitArray.length - 1];
        }
      }
    },
    initHKPlayBack() {
      this.HKwidth = $(`#playWnd${this.HKIdx}`).clientWidth;
      this.HKheight = $(`#playWnd${this.HKIdx}`).clientHeight;
      this.playBack();
    },
    // 创建播放实例
    initPlugin(callback) {
      const that = this;
      this.oWebControl = new WebControl({
        szPluginContainer: `playWnd${this.HKIdx}`, // 指定容器id
        iServicePortStart: 15900,
        iServicePortEnd: 15900,
        szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11", // 用于IE10使用ActiveX的clsid
        cbConnectSuccess: () => {
          // 创建WebControl实例成功
          that.oWebControl
            .JS_StartService("window", {
              // WebControl实例创建成功后需要启动服务
              dllPath: "./VideoPluginConnect.dll", // 值"./VideoPluginConnect.dll"写死
            })
            .then(
              () => {
                // 启动插件服务成功
                that.oWebControl.JS_SetWindowControlCallback({
                  // 设置消息回调
                  cbIntegrationCallBack: that.cbIntegrationCallBack,
                });
                that.oWebControl
                  .JS_CreateWnd(
                    `playWnd${this.HKIdx}`,
                    that.HKwidth,
                    that.HKheight,
                    { bEmbed: true }
                  )
                  .then(() => {
                    // JS_CreateWnd创建视频播放窗口，宽高可设定
                    that.initHKConfig(callback); // 创建播放实例成功后初始化
                    // 步骤4：发消息更新插件窗口位置：这里不直接更新的原因是，父页面默认可能就存在滚动条，此时有滚动量
                    this.resizeHKwindow();
                    window.frameElement && window.parent &&
                      window.parent.postMessage(
                        {
                          action: "updatePos",
                          msg: "更新Pos",
                        },
                        "*"
                      );
                  });
              },
              () => {
                // 启动插件服务失败
              }
            );
        },
        cbConnectError: () => {
          // 创建WebControl实例失败
          this.oWebControl = null;
          const downPlugin =
            "<br/><a href='/public/vendors/iot/VideoWebPlugin.exe'>点击安装插件！</a>";
          $(`#playWnd${this.HKIdx}`).html(
            "<p class='tip'>播放插件正在启动，请稍候..." + downPlugin + "</p>"
          );
          WebControl.JS_WakeUp("VideoWebPlugin://"); // 程序未启动时执行error函数，采用wakeup来启动程序
          that.initCount++;
          if (that.initCount < 3) {
            that.reConnectTimer = setTimeout(() => {
              that.initPlugin();
            }, 3000);
          } else {
            $(`#playWnd${this.HKIdx}`).html(
              "<br/><p  class='tip'>插件启动失败!" + downPlugin + "</p>"
            );
          }
        },
        cbConnectClose: (bNormalClose) => {
          // 异常断开：bNormalClose = false
          // JS_Disconnect正常断开：bNormalClose = true
          if (!bNormalClose) {
            // 创建WebControl实例失败
            this.oWebControl = null;
            const downPlugin =

              "<br/><a style='font-size: 12px;color:#4680ff;text-decoration:none'  href='/public/vendors/iot/VideoWebPlugin.exe'>点击安装插件</a>";
            $(`#playWnd${this.HKIdx}`).html(
              "<p class='tip' style='font-size: 12px;'>播放插件正在启动，请稍候..." + downPlugin + "</p>"
            );
            WebControl.JS_WakeUp("VideoWebPlugin://"); // 程序未启动时执行error函数，采用wakeup来启动程序
            that.initCount++;
            if (that.initCount < 3) {
              that.reConnectTimer = setTimeout(() => {
                that.initPlugin();
              }, 3000);
            } else {
              $(`#playWnd${this.HKIdx}`).html(
                "<br/><p  class='tip' style='font-size: 12px;'>您当前未安装播放器插件" + downPlugin + "</p>"
              );
            }
          }
        },
      });
    },
    // 设置窗口控制回调
    setCallbacks() {
      this.oWebControl.JS_SetWindowControlCallback({
        cbIntegrationCallBack: this.cbIntegrationCallBack,
      });
    },
    // 推送消息
    cbIntegrationCallBack(oData) {
      const { responseMsg } = oData
      const code = this.$parent.code ? this.$parent.code : ''

      if (responseMsg.type === 5) {
        if (responseMsg.msg.result === 1025) {
          this.$parent.$emit('callback', makeMessage(CALLBACK_ENUM.FULL_SCREEN,  code, 0))
        } else if(responseMsg.msg.result === 1024) {
          this.$parent.$emit('callback', makeMessage(CALLBACK_ENUM.FULL_SCREEN,  code, 1))
        }
      }
    },
    // 初始化
    initHKConfig(callback) {
      this.getPubKey(() => {
        // //////////////////////////////// 请自行修改以下变量值     ////////////////////////////////////
        const appkey = this.appKey; // 综合安防管理平台提供的appkey，必填
        const secret = this.setEncrypt(this.secret); // 综合安防管理平台提供的secret，必填
        const ip = this.ip; // 综合安防管理平台IP地址，必填
        const playMode = this.config && this.config.playMode ? Number(this.config.playMode) : 0; // 初始播放模式：0-预览，1-回放
        const port = this.port; // 综合安防管理平台端口，若启用HTTPS协议，默认443
        const snapDir = "D:\\SnapDir"; // 抓图存储路径
        const videoDir = "D:\\VideoDir"; // 紧急录像或录像剪辑存储路径
        const layout = this.config && this.config.layout ? this.config.layout : "1x1"; // playMode指定模式的布局
        const enableHTTPS =
          this.config && this.config.enableHTTPS ? Number(this.config.enableHTTPS) : 1; // 是否启用HTTPS协议与综合安防管理平台交互，是为1，否为0
        const encryptedFields = "secret"; // 加密字段，默认加密领域为secret
        const showToolbar =
          this.config && this.config.showToolBar ? 1 : 0 ; // 是否显示工具栏，0-不显示，非0-显示
        const showSmart =
          this.config && this.config.showSmart ? Number(this.config.showSmart) : 0; // 是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
        const buttonIDs =
          this.config && this.config.buttonIDs
            ? this.config.buttonIDs
            : ''; // 不传入默认显示全部

        const toolBarButtonIDs =
          this.config && this.config.toolBarButtonIDs
            ? this.config.toolBarButtonIDs : "2048,2049,2050,2304,2306,2305,2307,2308,2309,4096,4608,4097,4099,4098,4609,4100";
        // //////////////////////////////// 请自行修改以上变量值     ////////////////////////////////////

        const initParams = {
          appkey, // API网关提供的appkey
          secret, // API网关提供的secret
          ip, // API网关IP地址
          playMode, // 播放模式（决定显示预览还是回放界面）
          port, // 端口
          snapDir, // 抓图存储路径
          videoDir, // 紧急录像或录像剪辑存储路径
          layout, // 布局
          enableHTTPS, // 是否启用HTTPS协议
          encryptedFields, // 加密字段
          showToolbar, // 是否显示工具栏
          showSmart, // 是否显示智能信息
          toolBarButtonIDs
        }
        // 除非特殊场景指定该字段 否则默认不使用该字段 展示海康插件全部功能
        if (this.config && this.config.buttonIDs) {
          initParams.buttonIDs = buttonIDs
        }

        this.oWebControl
          .JS_RequestInterface({
            funcName: "init",
            argument: JSON.stringify(initParams),
          })
          .then((oData) => {
            console.log(oData);
            this.oWebControl.JS_Resize(this.HKwidth, this.HKheight); // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
            if (callback) {
              callback();
            }
          });
      });
    },
    // 获取公钥
    getPubKey(callback) {
      this.oWebControl
        .JS_RequestInterface({
          funcName: "getRSAPubKey",
          argument: JSON.stringify({
            keyLength: 1024,
          }),
        })
        .then((oData) => {
          if (oData.responseMsg.data) {
            this.pubKey = oData.responseMsg.data;
            callback();
          }
        });
    },
    // RSA加密
    setEncrypt(value) {
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(this.pubKey);
      return encrypt.encrypt(value);
    },
    // 设置窗口裁剪，当因滚动条滚动导致窗口需要被遮住的情况下需要JS_CuttingPartWindow部分窗口
    setWndCover() {
      var iframeWndHeight = $(window).height(); // iframe窗口高度
      var iframeWndWidth = $(window).width(); // iframe窗口宽度

      const oDivRect = $(`#playWnd${this.HKIdx}`)
        .get(0)
        .getBoundingClientRect();

      var divLeft = oDivRect.left;
      var divTop = oDivRect.top;
      var divRight = oDivRect.right;
      var divBottom = oDivRect.bottom;
      var divWidth = $(`#playWnd${this.HKIdx}`).width();
      var divHeight = $(`#playWnd${this.HKIdx}`).height();

      this.oWebControl.JS_RepairPartWindow(0, 0, this.HKwidth + 1, 401); // 多1个像素点防止还原后边界缺失一个像素条

      // 判断剪切矩形的上边距
      if (
        this.iframeClientPos.top < 0 &&
        Math.abs(this.iframeClientPos.top) > divTop
      ) {
        var deltaTop = Math.abs(this.iframeClientPos.top) - divTop;
        this.oWebControl.JS_CuttingPartWindow(0, 0, 801, deltaTop + 1);
        //console.log({deltaTop: deltaTop});
      }

      // 判断剪切矩形的左边距
      if (
        this.iframeClientPos.left < 0 &&
        Math.abs(this.iframeClientPos.left) > divLeft
      ) {
        var deltaLeft = Math.abs(this.iframeClientPos.left) - divLeft;
        //console.log({deltaLeft: deltaLeft});
        this.oWebControl.JS_CuttingPartWindow(0, 0, deltaLeft, 401); // 多剪掉一个像素条，防止出现剪掉一部分窗口后出现一个像素条
      }

      // 判断剪切矩形的右边距
      var W1 = iframeWndWidth - divRight;
      var W2 = this.iframeParentShowSize.width - this.iframeClientPos.left;
      if (W2 < divWidth) {
        var deltaRight = iframeWndWidth - W2 - W1;
        if (deltaRight > 0) {
          this.oWebControl.JS_CuttingPartWindow(
            800 - deltaRight,
            0,
            deltaRight + 1,
            401
          );
        }
      }

      // 判断剪切矩形的下边距
      var H1 = this.iframeClientPos.bottom - this.iframeParentShowSize.height;
      var H2 = iframeWndHeight - divBottom;
      var deltaBottom = H1 - H2;
      //console.log({deltaBottom: deltaBottom});
      if (deltaBottom > 0) {
        this.oWebControl.JS_CuttingPartWindow(
          0,
          400 - deltaBottom,
          801,
          deltaBottom + 1
        );
      }
    },
    // 多屏预览
    previewMultVideo(code) {
      const codes = code.split(',');
      const streamMode =
        this.config && this.config.streamMode
          ? this.config && this.config.streamMode
          : 0; // 主子码流标识：0-主码流，1-子码流
      // const transMode = 1; // 传输协议：0-UDP，1-TCP
      const transMode = (this.config.transType === undefined || this.config.transType === null) ? 1 : this.config.transType;
      const gpuMode = 0; // 是否启用GPU硬解，0-不启用，1-启用
      const lists = codes.map((item, index) => {
        const object = {};
        let cameraIndexCode = item;
        cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, "");
        cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, "");

        object.cameraIndexCode = cameraIndexCode;
        object.streamMode = streamMode;
        object.transMode = transMode;
        object.gpuMode = gpuMode;
        object.wndId = index + 1;
        return object;
      })

      let res = this.oWebControl.JS_RequestInterface({
          funcName: "startMultiPreviewByCameraIndexCode",
          argument: {
            list: lists
          }
      })

      return res;
    },

    // 单个预览
    previewVideo(code) {
      const streamMode =
        this.config && this.config.streamMode
          ? this.config && this.config.streamMode
          : 0; // 主子码流标识：0-主码流，1-子码流
      // const transMode = 1; // 传输协议：0-UDP，1-TCP
      const transMode = (this.config.transType === undefined || this.config.transType === null) ? 1 : this.config.transType;
      const gpuMode = 0; // 是否启用GPU硬解，0-不启用，1-启用
      const wndId = -1; // 播放窗口序号（在2x2以上布局下可指定播放窗口）
      let cameraIndexCode = code; // 获取输入的监控点编号值，必填

      cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, "");
      cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, "");

      this.oWebControl
        .JS_RequestInterface({
          funcName: "startPreview",
          argument: JSON.stringify({
            cameraIndexCode, // 监控点编号
            streamMode, // 主子码流标识
            transMode, // 传输协议
            gpuMode, // 是否开启GPU硬解
            wndId, // 可指定播放窗口
          }),
        })
        .then((res) => {
          this.oWebControl.JS_Resize(this.HKwidth, this.HKheight);
        });
    },
    // 设置当前布局
    setLayout(layout) {
      this.oWebControl && this.oWebControl.JS_RequestInterface({
          funcName: "setLayout",
          argument: JSON.stringify({
            layout,
          }),
        })
        .then((res) => {
          console.log(res);
        });
    },
    // 回放预览对外暴露接口
    previewBack(startTime, endTime, code, location) {
      this.HKstartTime = startTime;
      this.HKendTime = endTime;
      return this.playBack(location);
    },
    dispose() {
      this.initFlag = false;
      this.disposeEventListener();
      return this.closeWindow();
    },
    // 关闭视频窗口
    closeWindow() {
      return new Promise((resolve, reject) => {
        if (this.reConnectTimer != null) {
          clearTimeout(this.reConnectTimer);
        }
        if (this.oWebControl != null) {
          this.oWebControl.JS_HideWnd(); // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
          this.oWebControl.JS_Disconnect().then(
            () => {
              // 断开与插件服务连接成功
              console.log('断开插件服务成功')
              this.oWebControl = null;
              this.$emit('closeCallback',resolve())
              resolve();
            },
            () => {
              // 断开与插件服务连接失败
              console.log('断开插件服务失败')
              this.oWebControl = null;
              this.$emit('closeCallback',resolve())
              resolve();
            }
          );
        } else {
          this.$emit('closeCallback',resolve())
          resolve();
        }
      })
    },
    playBack(location) {
      let result = null;
      if (this.oWebControl === null) {
        this.initPlugin(() => {
          this.backVideo(this.HKvideoCode, this.HKstartTime, this.HKendTime, location);
        });
      } else {
        result = this.backVideo(
          this.HKvideoCode,
          this.HKstartTime,
          this.HKendTime,
          location
        );
      }
      return result;
    },
    async backVideo(code, starttime, endtime, location) {
      let cameraIndexCode = code; // 获取输入的监控点编号值，必填

      cameraIndexCode = cameraIndexCode.replace(/(^\s*)/g, "");
      cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, "");
      const startTime = String(parseInt(starttime / 1000));
      const endTime = String(parseInt(endtime / 1000));
      const recordLocation = Number(location);
      const transMode = (this.config.transType === undefined || this.config.transType === null) ? 1 : this.config.transType;
      if (isNaN(recordLocation)) {
        console.error("error：location 必须为0或 1", location);
        return;
      }
      const result = await this.oWebControl.JS_RequestInterface({
        funcName: "startPlayback",
        argument: JSON.stringify({
          cameraIndexCode, // 监控点编号
          startTimeStamp: startTime, // 录像查询开始时间戳，单位：秒
          endTimeStamp: endTime, // 录像查询结束时间戳，单位：秒
          recordLocation: location,
          transMode, // 传输协议 ，0-UDP 1-TCP
          gpuMode: 0, // 是否开启 GPU 硬解，0-不开启 1-开启
          wndId: -1, // 可指定播放窗口
        }),
      });
      console.log("HK playback result:", result);
      return result;
    },
    getCore() {
      return this.oWebControl;
    },
    // 隐藏Player
    hidePlayer() {
      if (this.oWebControl) {
        this.oWebControl.JS_HideWnd()
      }
    },
    // 显示Player
    showPlayer() {
      if (this.oWebControl) {
        this.oWebControl.JS_ShowWnd()
      }
    },
    // 偏移 错位
    resizePlayer() {
      this.resizeHKwindow();
    },
    // 监听该dom改变 并且触发海康播放器change
    listenExtenalDomChange() {
      if (!this.config || !this.config.extenalId) {
        return;
      }
      const element = document.getElementById(this.config.extenalId);
      if (!element) {
        return;
      }
      const throttleTimer = this.config && this.config.throttleTime || UPDATE_REFRESH_INTERVAL
      const throttleHandler = throttle(this.resizeHKwindow, throttleTimer)
      // 监听该dom的属性值改变 并出发播放器size改变
      const config = { attributes: true, childList: false, subtree: false };
      const observer = new MutationObserver((mutationsList, observer) => {
        throttleHandler()
      });
      observer.observe(element, config);
    },
    // 监听dom size
    listenDomResize() {
      const element = document.getElementById("hkVideo");
      const resizeObserver = new ResizeObserver(entries => {
        this.resizeHKwindow();
      });
      resizeObserver.observe(element);
    },
    // dom distory
    listenDestory() {
      const MutationObserver =
        window.MutationObserver ||
        window.WebKitMutationObserver ||
        window.MozMutationObserver;

      var observerOptions = {
        childList: true,
      }
      // 观察目标子节点的变化，是否有添加或者删除
      var observer = new MutationObserver((mutationsList, observer) => {
        const element = document.getElementById(`playWnd${this.HKIdx}`);
        if (!element) {
          this.dispose();
        }
      });
      observer.observe(document.body, observerOptions);
    },
    autoResize() {
      const MutationObserver =
        window.MutationObserver ||
        window.WebKitMutationObserver ||
        window.MozMutationObserver;
      const element = document.getElementById("hkVideo");
      const config = {
        attributes: true,
        childList: false,
        subtree: false,
        attributeFilter: ["style"],
      };

      if (!element) {
        console.warn("找不到父节点！")
        return;
      }

      let observer = new MutationObserver((mutationsList, observer) => {
        this.resizePlayWindows();
      });
      observer.observe(element, config);
      this.$once("hook:beforeDestroy", () => {
        observer.disconnect();
        observer.takeRecords();
        observer = null;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.hk-video {
  width: 100%;
  height: 100%;
}
.playWnd{
  display: flex;
  justify-content: center;
  align-items: center;

}
</style>